import i18n from "@/i18n";

export function getPublishedOptions() {
    return [
        { "label":i18n.t('apps.campaigns.list.datatable.all') , "value":"all" },
        { "label":i18n.t('apps.campaigns.list.datatable.published'), "value":'true' },
        { "label":i18n.t('apps.campaigns.list.datatable.unpublished'), "value":'false' },
    ]
}